import React, { Component, useState } from 'react';

import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';

import Loader from '../../../../Loader/Loader';

function DrawModal({modal, setModal}) {


    function toggle() {
        if (modal) {
            setModal(false);
        } else {
            setModal(true)
        }
    }

    return (
        <MDBContainer>
            <MDBModal isOpen={modal} toggle={toggle}>
                <MDBModalBody>
                    Trekning pågår
                    <Loader />
                </MDBModalBody>
            </MDBModal>
        </MDBContainer>
        );
    }

export default DrawModal;